import React from "react";

// components
import PageTitle from "../../components/PageTitle/PageTitle";
import LoadingOverlay from 'react-loading-overlay';
import GiorniListWidget from "../../widgets/GiorniListWidget";
import { NineCellLoading } from 'react-loadingg';
import translateString from "../../utils/Locales";

let t = translateString;

export default class Scuola extends React.Component {

  constructor(props){
    super (props)
  
    this.pageDiv = {
      border: '1px solid #cccccc',
      padding: 10
    };
  
    this.section = this.props.section
    if (this.section == undefined){
      const pathname = props.location.pathname;
      this.section = pathname.substring(8, pathname.length);
    }

    this.pageTitle = props.pageTitle;
    this.pageName = props.pageName;
    if (this.pageName == undefined){
      this.pageName = this.section;
    }

    this.userslist = [];

    this.state = {
      testo: '',
      menuBackground: '#ffffff',
      menuItemColor: '#000000',
      fontSize: 50,
      fontBold: false,
      logoPicture: '',
      logoMargin: 0,
      titleColor: '#000000',
      titleSize: 18,
      isLoading: true,
      addElementVisible: false,
      giorniChiusura: []
    }

    this.grid = 2;
    this.startDateRef = React.createRef();
    this.endDateRef = React.createRef();
  }

  async componentDidMount(){
      this.setState({ isLoading: false });
  }

  render () {

    function createData(username, name, surname) {
      return { username, name, surname };
    }

    var rows = [];
    this.userslist.length > 0 && this.userslist.map((v, k) => {
      rows.push(createData(v.username, v.name, v.surname));
    });

    if (this.state.isLoading) return <NineCellLoading style={{ position: 'absolute', left: '55%', top: '50%' }} />

    return (
      <>
      <LoadingOverlay
      active={this.state.isLoading}
      styles={{
        content: (base) => ({
          position: 'relative',
          width: '100%',
          top: '200px'
        })
      }}
      spinner
      text={'Loading your content...'}
      >
          <PageTitle title={t('scuola')} />

          <p style={{ marginLeft: 5, fontWeight: 'bold', marginBottom: -15, color: 'darkgray',  }}>{t('giorni_chiusura')}</p><br/>
          <div style={{ display: 'flex', marginLeft: 5, marginBottom: -10 }}>
            <img alt="" src={ require('../../images/question_icon.png') } style={{ width: 10, height: 10, marginRight: 5, marginTop: 1 }} />
            <p style={{ fontSize: 10, color: 'darkgray', }}>{t('feste_info')}</p><br/>
          </div>
          <GiorniListWidget id={Math.random()} name={t('giorni_chiusura')} value={this.state.giorniChiusura} onChange={(giorni) => { }} />
        </LoadingOverlay>
      </>
    );
  }


}

